import { Api } from "../..";
import {
  API_GET_AI_STORY_BY_ID
} from "../../Apis/ApiEndPoints";

import { CustomAction } from "../../store/customAction";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { IGetAIStoryByIdResponse } from "./Underwriter.types";


export const getAIStoryById = createAsyncThunk(
  "underwriter/getAIstory",
  async (id:string, { dispatch }) => {
    const response: IGetAIStoryByIdResponse = await CustomAction(
      Api.get(`${API_GET_AI_STORY_BY_ID}/${id}`),
      dispatch,
      "underwriter/getAIstory"
    );
    return response;
  }
);
